// // src/components/Loader.jsx
// import React from 'react';
// import './Loader.css';

// /**
//  * Reusable Professional Loader component
//  * @param {string} message - Custom message to display
//  * @param {boolean} fullScreen - Centered full-screen overlay
//  * @param {boolean} overlay - Centered container overlay
//  * @param {boolean} inline - Compact inline button spinner
//  * @param {string} size - 'sm', 'md', 'lg'
//  */
// const Loader = ({ message = 'Loading workspace...', fullScreen = false, overlay = false, inline = false, size = 'md' }) => {
//   if (inline) {
//     return <span className={`inline-spinner inline-spinner-${size}`} role="status" aria-hidden="true" />;
//   }

//   const loaderCard = (
//     <div className={`professional-loader-card loader-card-${size}`}>
//       {/* Brand Logo & Orbit Spinner Header */}
//       <div className="loader-brand-wrapper">
//         <div className="loader-orbit-ring" />
//         <div className="loader-orbit-ring-secondary" />
//         <img src="/gtelinq_logo.png" alt="GTELINQ Logo" className="loader-brand-logo" />
//       </div>

//       {/* Title & Message */}
//       <div className="loader-content-block">
//         <h4 className="loader-brand-title">Employee Self-Onboarding</h4>
//         <div className="loader-status-msg">
//           <span>{message}</span>
//           <span className="loader-dots">
//             <span className="dot dot-1">.</span>
//             <span className="dot dot-2">.</span>
//             <span className="dot dot-3">.</span>
//           </span>
//         </div>
//       </div>

//       {/* Shimmering Gradient Progress Line */}
//       <div className="loader-progress-track">
//         <div className="loader-progress-bar" />
//       </div>
//     </div>
//   );

//   if (fullScreen) {
//     return (
//       <div className="professional-loader-fullscreen fade-in">
//         {loaderCard}
//       </div>
//     );
//   }

//   if (overlay) {
//     return (
//       <div className="professional-loader-parent-overlay fade-in">
//         {loaderCard}
//       </div>
//     );
//   }

//   return (
//     <div className="professional-loader-center-wrapper fade-in">
//       {loaderCard}
//     </div>
//   );
// };

// export default Loader;














// src/components/Loader.jsx
import React from 'react';
import ReactDOM from 'react-dom';
import './Loader.css';

/**
 * Reusable Professional Loader component
 * @param {string} message - Custom message to display
 * @param {boolean} fullScreen - Centered full-screen overlay
 * @param {boolean} overlay - Centered container overlay
 * @param {boolean} inline - Compact inline button spinner
 * @param {string} size - 'sm', 'md', 'lg'
 */
const Loader = ({ message = 'Loading workspace...', fullScreen = false, overlay = false, inline = false, size = 'md' }) => {
  if (inline) {
    return <span className={`inline-spinner inline-spinner-${size}`} role="status" aria-hidden="true" />;
  }

  const loaderCard = (
    <div className={`professional-loader-card loader-card-${size}`}>
      {/* Brand Logo & Orbit Spinner Header */}
      <div className="loader-brand-wrapper">
        <div className="loader-orbit-ring" />
        <div className="loader-orbit-ring-secondary" />
        <img src="/gtelinq_logo.png" alt="GTELINQ Logo" className="loader-brand-logo" />
      </div>

      {/* Title & Message */}
      <div className="loader-content-block">
        <h4 className="loader-brand-title">Employee Self-Onboarding</h4>
        <div className="loader-status-msg">
          <span>{message}</span>
          <span className="loader-dots">
            <span className="dot dot-1">.</span>
            <span className="dot dot-2">.</span>
            <span className="dot dot-3">.</span>
          </span>
        </div>
      </div>

      {/* Shimmering Gradient Progress Line */}
      <div className="loader-progress-track">
        <div className="loader-progress-bar" />
      </div>
    </div>
  );

  if (fullScreen) {
    return ReactDOM.createPortal(
      <div className="professional-loader-fullscreen fade-in">
        {loaderCard}
      </div>,
      document.body
    );
  }

  if (overlay) {
    return (
      <div className="professional-loader-parent-overlay fade-in">
        {loaderCard}
      </div>
    );
  }

  return (
    <div className="professional-loader-center-wrapper fade-in">
      {loaderCard}
    </div>
  );
};

export default Loader;
